export enum ACTIVE {
  CHANGED = 'activeVehicleChanged',
  MILEAGE_CHANGED = 'activeVehicleMileageChanged',
  REMOVED = 'activeVehicleRemoved',
  SET = 'activeVehicleSet'
}

export enum EVENTS {
  ADD_COMPLETE = 'ADD_VEHICLE_COMPLETE',
  AUTO_GARAGE_ADDED = 'autoGarageVehicleAdded',
  WIDGET_LOADED = 'vehicleWidgetLoaded',
  LAST_ACTIVE_LOADED = 'lastActiveVehicleLoaded',
  UN_AUTH_CHANGED = 'unAuthVehicleChanged',
  PROFILE_AVAILABLE = 'vehicleProfileVehicleAvailable',
  AUTO_SYNC_GARAGE_COMPLETE = 'autoSyncGarageComplete',
  CANCEL_CAPTCHA = 'cancelCaptcha',
  COLLAPSE_WIDGETS = 'gmCollapseWidgets',
  LANGUAGE_CHANGED = 'languageChanged',
  MY_ACCOUNT_VIN_UPDATED = 'myAccountVinUpdated',
  NOO_MODAL_CLOSED = 'nooModalClosed',
  ON_STAR_LEGAL_CHANGED = 'onStarLegalChanged',
  REMOVE_PROFILE_CONFIRM = 'removeProfileConfirm',
  RETRIEVED_POINTS_OF_INTEREST = 'retrievedPointsOfInterest',
  SEND_TO_CAR_INFO_BOXClicked = 'sendToCarInfoBoxClicked',
  USER_LOADED = 'gmUserLoaded',
  USER_UNLOADED = 'gmUserUnloaded',
  WINDOW_RESIZED = 'gmWindowResized',
  VIN_ADDED_TO_ACTIVE_VEHICLE = 'vinAddedToActiveVehicle',
  GMOC_APP_INITIALIZED = 'gmocAppInitialized',
  LOYALTY_ENROLLED = 'loyaltyEnrolled'
}

export const EVENT_KEYS = {
  VEHICLE: {ACTIVE},
  ...EVENTS
} as const;
